import React, { useEffect, useState } from "react";
import { Row, Col, Form, Card, CardBody } from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import moment from "moment";
import config from "../../utils/config";
import { useSelector } from "react-redux";

export default function TestimonialPreviewPage(props) {
  const {  userProfile } = useSelector((state) => state.Auth);

  return (
    <React.Fragment>
      <div className="hideSearch mt-4">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={`${props &&
                  props.testimonialData &&
                  props.testimonialData.name} by ${userProfile.fName} ${userProfile.lName}`}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>Partner Detail</span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name="Name"
                    titleName={`${userProfile.fName} ${userProfile.lName}`}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name="Email"
                    titleName={`${userProfile.contact.email}`}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>Testimonial Detail</span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name="Rider Name"
                    titleName={
                      props &&
                      props.testimonialData &&
                      props.testimonialData.name
                        ? props.testimonialData.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name="Rider Location"
                    titleName={
                      props &&
                      props.testimonialData &&
                      props.testimonialData.country
                        ? props.testimonialData.country
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name="Posted Date"
                    titleName={
                      props &&
                      props.testimonialData &&
                      props.testimonialData.postedDate
                        ? moment(props.testimonialData.postedDate).format(
                            "DD/MM/YYYY"
                          )
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name="Rider Note"
                    titleName={
                      props &&
                      props.testimonialData &&
                      props.testimonialData.description
                        ? props.testimonialData.description
                        : "N/A"
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>Media</span>
                  </h2>
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <div className="image_heading">
                    Rider Image/Default image (80 x 80 px)
                  </div>
                  {props &&
                  props.testimonialData &&
                  props.testimonialData.image ? (
                    <img
                      className="image_bikeman"
                      src={`${config.imageBaseUrl}/${props &&
                        props.testimonialData &&
                        props.testimonialData.image}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>
              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5">
                <CustomButton
                  customType={"button"}
                  name="Back"
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() => props.handleToggleModel()}
                />
              </div>
            </CardBody>
          </Card>
        </Form>
      </div>
    </React.Fragment>
  );
}
